import React, { useEffect, } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createMember, getMember, resetState, updateMember } from "../../Association/features/member/memberSlice";
import { toast } from "react-toastify";
import CustomInput from "../components/CustomInput";

let schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  email: yup.string().required("Email is Required"),
  password: yup.string().required("Password is Required"),

});

const AddMember = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const NewsState = useSelector((state) => state.member);
  const { isSuccess, isError, isLoading, createdMember, membername, memberemail, memberpassword, updatedMember } = NewsState;

  const token = useSelector((state) => state.autht.token);

  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getMember(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [dispatch, getNewsId]);

  useEffect(() => {
    dispatch(resetState());

  }, [dispatch]);

  useEffect(() => {
    if (isSuccess && createdMember) {
      toast.success("Member Added Successfully!");
      dispatch(resetState());
    }
    if (isSuccess && updatedMember) {
      toast.success("Member Updated Successfully!");
      navigate("/association/Member-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {

      name: membername || "",
      email: memberemail || "",
      password: memberpassword || "",
      token: token
    },
    validationSchema: schema,
    onSubmit: (values) => {

      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: values };
        dispatch(updateMember(data));
        dispatch(resetState());
      } else {
        dispatch(createMember(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });



  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Member</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Member Name"
              name="name"
              onChng={formik.handleChange("name")}
              onBlr={formik.handleBlur("name")}
              val={formik.values.name}
            />
            <div className="error">{formik.touched.name && formik.errors.name}</div>
          </div>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Email Address"
              name="email"
              val={formik.values.email}
              onChng={formik.handleChange("email")}
              onBlr={formik.handleBlur("email")}
            />
            <div className="error">{formik.touched.email && formik.errors.email}</div>
          </div>
          <div className="mt-4">
            <CustomInput
              type="password"
              label="Password"
              name="password"
              val={formik.values.password}
              onChng={formik.handleChange("password")}
              onBlr={formik.handleBlur("password")}
            />
            <div className="error">{formik.touched.password && formik.errors.password}</div>
          </div>




          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} Member
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddMember;